import type { MouseEvent } from 'react';
import { NAV_TABS, activeTab } from '../app/navigation';
import { navigate, useLocation } from '../lib/router';
import { useAuth } from '../state/auth';
import { Icon } from './ui/Icon';
import { Avatar, cx } from './ui/primitives';
import styles from './nav.module.css';

export function BottomNav({ immersive }: { immersive: boolean }) {
  const { pathname } = useLocation();
  const { me, requireAuth } = useAuth();
  const active = activeTab(pathname);

  return (
    <nav className={cx(styles.nav, immersive && styles.immersive)} aria-label="Hoofdnavigatie">
      {NAV_TABS.map((tab) => {
        const isActive = tab.id === active;
        const go = (e: MouseEvent) => {
          e.preventDefault();
          if (tab.requiresAuth && !requireAuth(tab.id === 'create' ? 'Log in om video’s te maken' : 'Log in om je profiel te zien')) return;
          if (isActive && pathname === tab.path) {
            window.dispatchEvent(new CustomEvent('bb:tab-reselect', { detail: tab.id }));
            return;
          }
          navigate(tab.path);
        };
        if (tab.primary) {
          return (
            <a key={tab.id} href={tab.path} onClick={go} className={styles.create} aria-label={tab.label}>
              <span className={styles.createInner}>
                <Icon name={tab.icon} size={22} strokeWidth={2.6} />
              </span>
            </a>
          );
        }
        const showAvatar = tab.id === 'profile' && me;
        return (
          <a key={tab.id} href={tab.path} onClick={go} className={cx(styles.tab, isActive && styles.active)} aria-current={isActive ? 'page' : undefined}>
            <span className={styles.iconWrap}>
              {showAvatar ? <Avatar user={me} size={24} /> : <Icon name={tab.icon} size={24} filled={isActive && tab.icon !== 'discover'} strokeWidth={isActive ? 2.2 : 1.8} />}
              {tab.id === 'profile' && (me?.unreadNotifications ?? 0) > 0 && <span className={styles.badge} aria-label={`${me!.unreadNotifications} nieuwe meldingen`} />}
            </span>
            <span className={styles.label}>{tab.label}</span>
          </a>
        );
      })}
    </nav>
  );
}
